export default __webpack_public_path__ + "static/media/ac (1).da3db378.svg";